import { AssetScreenMapping, OnuScreenMapping, RegisteredApplications, } from '../types';
export const getScreenMapping = (application) => {
    if (application === RegisteredApplications.APP_ONU_MAIN) {
        return OnuScreenMapping;
    }
    return AssetScreenMapping;
};
export const getCurrentScreen = (pathname, application) => {
    const screenMapping = getScreenMapping(application);
    let currentScreen = undefined;
    if (pathname === '/') {
        currentScreen = screenMapping[pathname];
    }
    Object.keys(screenMapping).forEach(key => {
        if (pathname.includes(key) && key !== '/') {
            currentScreen = screenMapping[key];
        }
    });
    return currentScreen;
};
